import { environment } from '~/environments';

export const GRIMME_STATIC_IMAGE_URL = 'https://static.grimme.com/files';

const BANNER_HIGH_QUALITY = 85;
const BANNER_HIGH_WIDTH = 1920;
const BANNER_LOW_QUALITY = 30;
const BANNER_LOW_WIDTH = 980;
const DEFAULT_HIGH_QUALITY = 70;
const DEFAULT_HIGH_WIDTH = 1280;
const DEFAULT_LOW_QUALITY = 30;
const DEFAULT_LOW_WIDTH = 640;
const THUMBNAIL_LOW_QUALITY = 30;
const THUMBNAIL_LOW_WIDTH = 300;
const THUMBNAIL_HIGH_QUALITY = 90;
const THUMBNAIL_HIGH_WIDTH = 700;

const isProd = environment.appEnv === 'prod';

const PROD_IMG_CONFIG = {
  banner: {
    quality: BANNER_HIGH_QUALITY,
    width: BANNER_HIGH_WIDTH,
  },
  default: {
    quality: DEFAULT_HIGH_QUALITY,
    width: DEFAULT_HIGH_WIDTH,
  },
  thumbnail: {
    quality: THUMBNAIL_HIGH_QUALITY,
    width: THUMBNAIL_HIGH_WIDTH,
  },
};

const TST_IMG_CONFIG = {
  banner: {
    quality: BANNER_LOW_QUALITY,
    width: BANNER_LOW_WIDTH,
  },
  default: {
    quality: DEFAULT_LOW_QUALITY,
    width: DEFAULT_LOW_WIDTH,
  },
  thumbnail: {
    quality: THUMBNAIL_LOW_QUALITY,
    width: THUMBNAIL_LOW_WIDTH,
  },
};

// Assign the appropriate configuration based on the app environment
export const IMG_CONFIG = isProd ? PROD_IMG_CONFIG : TST_IMG_CONFIG;

export enum AvatarImgSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export const AVATAR_IMG_CONFIG: Record<
  AvatarImgSize,
  { height?: number; quality: number; width?: number }
> = {
  [AvatarImgSize.SM]: { quality: 80, width: 40 },
  [AvatarImgSize.MD]: { quality: 80, width: 48 },
  [AvatarImgSize.LG]: { quality: 80, width: 56 },
  [AvatarImgSize.XL]: { quality: 80, width: 64 },
};
